import React, {useEffect, useState} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {Spin} from 'antd';
import {authApi} from '@/api/auth';

type Props = {
	children: React.ReactNode;
};

const styles: React.CSSProperties = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	minHeight: '60vh',
};

export const ProtectedRoute: React.FC<Props> = ({children}) => {
	const [status, setStatus] = useState<'pending' | 'ok' | 'unauthorized'>('pending');
	const location = useLocation();

	useEffect(() => {
		authApi.me().then(({status: s}) => {
			setStatus(s === 200 ? 'ok' : 'unauthorized');
		});
	}, []);

	switch (status) {
		case 'pending':
			return (
				<div style={styles}>
					<Spin size="large" />
				</div>
			);
		case 'unauthorized':
			return <Navigate to="/login" state={{from: location}} replace />;
		default:
			return <>{children}</>;
	}
};
